import { fromJS, List } from 'immutable';
import { Interval } from 'domain/Interval';
import IdpList from './model';
import SkillResult from '../SkillResult';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillResults':
      return [key, new List(val.map((skill) => new SkillResult(skill)))];
    case 'period':
      return [key, Interval.create({
        start: val.startDate,
        end: val.endDate,
      })];
    default:
      return [key, fromJS(val)];
  }
};

const create = (data) => new IdpList(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpList/create.js